import { render } from "./PurchaseTableAdmin.vue?vue&type=template&id=e15a7db0"
import script from "./PurchaseTableAdmin.vue?vue&type=script&lang=js"
export * from "./PurchaseTableAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__